module.exports = __webpack_public_path__ + "img/cooperation_unit_11.652e34ce.png";